import { apiClient } from '@/lib/api/client';
import type {
  DashboardMetricsResponse,
  DashboardChartsResponse,
  DashboardRankingsResponse,
  DashboardSummaryResponse,
} from '../types/dashboard.types';

export const dashboardService = {
  /**
   * Get dashboard metrics for a date range
   */
  async getMetrics(startDate: string, endDate: string): Promise<DashboardMetricsResponse> {
    const response = await apiClient.get<DashboardMetricsResponse>('/dashboard/metrics', {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data;
  },

  /**
   * Get dashboard chart data
   */
  async getCharts(monthsBack: number = 6): Promise<DashboardChartsResponse> {
    const response = await apiClient.get<DashboardChartsResponse>('/dashboard/charts', {
      params: {
        monthsBack,
      },
    });
    return response.data;
  },

  /**
   * Get dashboard rankings data
   */
  async getRankings(topN: number = 5): Promise<DashboardRankingsResponse> {
    const response = await apiClient.get<DashboardRankingsResponse>('/dashboard/rankings', {
      params: {
        topN,
      },
    });
    return response.data;
  },

  /**
   * Resumen completo del dashboard en una sola llamada (ventana máxima de 3 meses)
   */
  async getSummary(startDate: string, endDate: string): Promise<DashboardSummaryResponse> {
    const response = await apiClient.get<DashboardSummaryResponse>('/dashboard/summary', {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data;
  },
};
